// extracted by mini-css-extract-plugin
export default {"form":"MealitemForm_form__IJHyY"};